export const getLangText = (uaText, ruText, $i18n) => {
  return $i18n.locale === 'ru' ? ruText : uaText
}

import debounce from 'lodash/debounce'
const DEBOUNCE_TIME = 50

export const createScrollListener = ({ element, callback }) => {
  const footerElement = document.querySelector('#footer')
  const metaElement = document.querySelector('#meta-content')
  const sidebar = document.querySelector('#sidebar')
  const elems = [footerElement, metaElement]

  const hiddenBottomContent = () => {
    elems.forEach((el) => {
      el && el.setAttribute('hidden', '')
    })
    sidebar.classList.add('remove-padding')
    window.removeEventListener('scroll', hiddenBottomContent)
  }
  const showBottomContent = () => {
    window.removeEventListener('scroll', hiddenBottomContent)

    elems.forEach((el) => {
      el && el.removeAttribute('hidden')
    })
    sidebar.classList.remove('remove-padding')
  }

  const onScroll = () => {
    if (element) {
      const rect = element.getBoundingClientRect()
      if (rect.bottom / 2 <= window.innerHeight) {
        callback()
      }
    }
  }

  const scrollHandler = debounce(() => onScroll(), DEBOUNCE_TIME)

  return {
    start() {
      window.addEventListener('scroll', scrollHandler)
    },
    stop() {
      window.removeEventListener('scroll', scrollHandler)
    },
    hiddenBottomContent() {
      window.addEventListener('scroll', hiddenBottomContent)
    },
    showBottomContent,
  }
}

export const calculateEmptySlots = ({ list, card, length }) => {
  if (!list || !card || !length) return 0
  const gapValue = parseFloat(getComputedStyle(list).gap)
  const cardWidth = card.clientWidth + gapValue
  const cardHeight = card.clientHeight + gapValue
  const listWidth = list.clientWidth - gapValue
  const listHeight = list.clientHeight - gapValue

  const itemsCol = Math.ceil(listWidth / cardWidth)
  const itemsRow = Math.ceil(listHeight / cardHeight)

  return (itemsCol * itemsRow) - length
}
